import { IStore } from 'redux/IStore';
import { IPage } from 'models/common';
import {
	IWardrobeItemSearchResultsData,
	IWardrobeItemSearchResultsAction,
} from 'models/search/productbasesearchresults';
import { IWardrobeItemsResponse } from 'models/product/search/productsResponse';
import { IProductsRequest } from 'models/product/search/productsRequest';
import { IRefinementGroup } from 'models/filtering/refinement';
import * as c from 'models/constants';
import { ProductBaseSearch } from '../productBaseSearch';
import { LikeNodeType } from 'models/enums/nodetype/likenodetype';
import { Likes } from 'redux/modules/user/likes';
import { IUserPreferences } from 'models/user/userpreferences';
import { SearchUsage } from 'models/enums/searchusage';
import { actions as notifActions } from 'redux-notifications';
import { IWardrobeItemListCard } from 'models/wardrobe/wardrobeitemlistcard';
import * as i18n from 'i18next';
import { Wishlists } from 'redux/modules/user/wishlists';
import { WishlistNodeType } from 'models/enums/nodetype/wishlistnodetype';
const { notifSend } = notifActions;

/** Action Types */
export const REQUEST_START: string = 'wardrobeitemsearchresults/REQUEST_START';
export const REQUEST_FAILURE: string = 'wardrobeitemsearchresults/REQUEST_FAILURE';
export const GET_WARDROBEITEMS_SUCCESS: string = 'wardrobeitemsearchresults/GET_WARDROBEITEMS_SUCCESS';
export const SET_ITEMS_PAGE: string = 'wardrobeitemsearchresults/SET_ITEMS_PAGE';
export const RESET_DATA: string = 'wardrobeitemsearchresults/RESET_DATA';
export const RESET_SEARCH_DATA: string = 'wardrobeitemsearchresults/RESET_SEARCH_DATA';
export const SET_SEARCHED_KEYWORD: string = 'wardrobeitemsearchresults/SET_SEARCHED_KEYWORD';
export const SET_SELECTED_CATEGORY: string = 'wardrobeitemsearchresults/SET_SELECTED_CATEGORY';
export const SET_SORT_ORDER: string = 'wardrobeitemsearchresults/SET_SORT_ORDER';
export const RESET_FILTERS: string = 'wardrobeitemsearchresults/RESET_FILTERS';
export const SET_REFINEMENT_LASTSELECTION: string = 'wardrobeitemsearchresults/SET_REFINEMENT_LASTSELECTION';
export const SET_REFINEMENT_SELECTIONS: string = 'wardrobeitemsearchresults/SET_REFINEMENT_SELECTIONS';
export const SET_REFINEMENT_GROUPS: string = 'wardrobeitemsearchresults/SET_REFINEMENT_GROUPS';
export const SET_REFINEMENT_NARROWSELECTION: string = 'wardrobeitemsearchresults/SET_REFINEMENT_NARROWSELECTION';
export const LIKE_ITEM_SUCCESS: string = 'wardrobeitemsearchresults/LIKE_ITEM_SUCCESS';
export const WISHLIST_ITEM_SUCCESS: string = 'wardrobeitemsearchresults/WISHLIST_ITEM_SUCCESS';
export const LIKE_REQUEST_START: string = 'wardrobeitemsearchresults/LIKE_REQUEST_START';
export const LIKE_REQUEST_FAILURE: string = 'wardrobeitemsearchresults/LIKE_REQUEST_FAILURE';

/** Initial State */
const initialState: IWardrobeItemSearchResultsData = {
	items: [],
	isFetching: false,
	itemsPage: {
		currentPage: 0,
		totalPages: 0,
		totalItems: 0,
		itemsPerPage: 10,
		items: [],
	},
	keyword: '',
	sortOrder: null,
	refinementGroups: [],
	refinementSelections: [],
	lastSelectedRefinementItemId: null,
	lastSelectedRefinementGroupId: null,
	lastActionWasToNarrowRefinement: false,
	selectedCategoryId: null,
	isFetchingLikes: false,
};

/** Reducer */
export function wardrobeItemSearchResultsReducer(state = initialState, action: IWardrobeItemSearchResultsAction) {
	switch (action.type) {
		case REQUEST_START:
			return Object.assign({}, state, {
				isFetching: true,
				error: false,
			});

		case GET_WARDROBEITEMS_SUCCESS:
			return Object.assign({}, state, {
				items: action.payload.items,
				isFetching: false,
			});

		case REQUEST_FAILURE:
			return Object.assign({}, state, {
				isFetching: false,
				message: action.payload.message,
				error: true,
			});

		case SET_ITEMS_PAGE:
			return Object.assign({}, state, {
				itemsPage: action.payload.itemsPage,
			});

		case RESET_DATA:
			return Object.assign({}, state, {
				items: [],
				isFetching: false,
				itemsPage: {
					currentPage: 0,
					totalPages: 0,
					totalItems: 0,
					itemsPerPage: 10,
					items: [],
				},
			});

		case RESET_SEARCH_DATA:
			return Object.assign({}, state, {
				items: [],
				isFetching: false,
				itemsPage: {
					currentPage: 0,
					totalPages: 0,
					totalItems: 0,
					itemsPerPage: 10,
					items: [],
				},
				sortOrder: null,
				refinementGroups: [],
				refinementSelections: [],
				lastSelectedRefinementItemId: null,
				lastSelectedRefinementGroupId: null,
				lastActionWasToNarrowRefinement: false,
				selectedCategoryId: null,
			});

		case SET_SEARCHED_KEYWORD:
			return Object.assign({}, state, {
				keyword: action.payload.keyword,
			});

		case SET_SELECTED_CATEGORY:
			return Object.assign({}, state, {
				selectedCategoryId: action.payload.selectedCategoryId,
			});

		case SET_SORT_ORDER:
			return Object.assign({}, state, {
				sortOrder: action.payload.sortOrder,
				isFirstLoad: true,
			});

		case SET_REFINEMENT_SELECTIONS:
			return Object.assign({}, state, {
				refinementSelections: action.payload.refinementSelections,
			});

		case SET_REFINEMENT_GROUPS:
			return Object.assign({}, state, {
				refinementGroups: action.payload.refinementGroups,
			});

		case SET_REFINEMENT_LASTSELECTION:
			return Object.assign({}, state, {
				lastSelectedRefinementItemId: action.payload.lastSelectedRefinementItemId,
				lastSelectedRefinementGroupId: action.payload.lastSelectedRefinementGroupId,
			});

		case SET_REFINEMENT_NARROWSELECTION:
			return Object.assign({}, state, {
				wlastActionWasToNarrowRefinement: action.payload.lastActionWasToNarrowRefinement,
			});

		case WISHLIST_ITEM_SUCCESS:
			return Object.assign({}, state, {
				isFetching: false,
			});

		case LIKE_REQUEST_START:
			return Object.assign({}, state, {
				isFetchingLikes: true,
			});

		case LIKE_ITEM_SUCCESS:
			return Object.assign({}, state, {
				isFetchingLikes: false,
			});

		case LIKE_REQUEST_FAILURE:
			return Object.assign({}, state, {
				isFetchingLikes: false,
				message: action.payload.message,
				error: true,
			});

		default:
			return state;
	}
}

/** Action Creator */
export function getWardrobeItemsSearchResults(isFirstLoad: boolean, isRefinement: boolean, usage: SearchUsage) {
	return (dispatch, getState: () => IStore) => {
		if (isFirstLoad) {
			dispatch(resetData());
		}

		dispatch(requestStart());

		const state: IWardrobeItemSearchResultsData = getState().wardrobeItemSearchResults;

		const currentPage: number = state.itemsPage.currentPage;
		const newPage: number = currentPage + 1;
		const itemsPerPage: number = state.itemsPage.itemsPerPage;
		const userPreferences: IUserPreferences = getState().userPreferences;

		const productsRequest: IProductsRequest = {
			currentPage: newPage,
			itemsPerPage,
			refinementGroups: state.refinementSelections,
			categoryId: state.selectedCategoryId,
			orderBy: state.sortOrder,
		};

		let method = 'search';
		if (usage === SearchUsage.WardrobeItemsOuttfitSearch) {
			productsRequest.searchKeyword = state.keyword;
		} else if (usage === SearchUsage.WardrobeItemsUserCard || usage === SearchUsage.OutfitWardrobeItems) {
			if (getState().usercard.isMyProfile) {
				productsRequest.published = false;
			} else {
				productsRequest.published = true;
			}
			method = 'getbyuser/' + getState().usercard.usercard.id;
		}

		return fetch(
			getState().fetchDefault.baseAPI + 'api/wardrobeitem/' + method,
			Object.assign({}, getState().fetchDefault.requestInit, {
				method: 'POST',
				body: JSON.stringify(productsRequest),
			}),
		)
			.then((res) => {
				if (res.ok) {
					return res.json().then((res: IWardrobeItemsResponse) => {
						if (isFirstLoad) {
							dispatch(resetData());
						}
						const wardrobeItemSearchResultsState: IWardrobeItemSearchResultsData = getState().wardrobeItemSearchResults;
						const items: IWardrobeItemListCard[] = wardrobeItemSearchResultsState.items;
						const newItems: IWardrobeItemListCard[] = res.wardrobeItems.items;
						Array.prototype.push.apply(items, newItems);
						dispatch(getWardrobeItemsSuccess(items));
						dispatch(setItemsPage(res.wardrobeItems));
						const productBase = new ProductBaseSearch(dispatch, c.NODE_TYPE_WARDROBE, usage);
						const likes = new Likes(LikeNodeType.WardrobeItemSearch);
						const wishlists = new Wishlists(WishlistNodeType.WardrobeItemSearch);
						if (isRefinement) {
							dispatch(productBase.filterOutRefinements(res.refinementGroups));
						} else {
							productBase.setInitialRefinementsGroups(res.refinementGroups);
						}
						if (userPreferences && userPreferences.id) {
							dispatch(likes.getLikedItems());
							dispatch(wishlists.getWishlistedItems());
						} else {
							dispatch(likes.updateLikeItems(null));
							dispatch(wishlists.updateWishlistItems(null));
						}
					});
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(requestFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(requestFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(requestFailure(err));
			});
	};
}

/** Async Action Creator */
export function deleteWardrobeItem(itemId: string) {
	return (dispatch, getState: () => IStore) => {
		dispatch(requestStart());
		return fetch(
			getState().fetchDefault.baseAPI + 'api/WardrobeItem/' + itemId,
			Object.assign({}, getState().fetchDefault.requestInit, {
				method: 'DELETE',
			}),
		)
			.then((res) => {
				if (res.ok) {
					dispatch(deleteWardrobeItemFromList(itemId));
					dispatch(
						notifSend({
							message: i18n.t('Notification_Success_Wardrobe_Item_Deleted'),
							kind: 'success',
							dismissAfter: 3000,
						}),
					);
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(requestFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(requestFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(requestFailure(err));
			});
	};
}

/** Action Creator */
export function deleteWardrobeItemFromList(itemId: string) {
	return (dispatch, getState: () => IStore) => {
		const items: IWardrobeItemListCard[] = getState().wardrobeItemSearchResults.items;
		const index = items.indexOf(items.find((x: IWardrobeItemListCard) => x.id === itemId));
		items.splice(index, 1);
		dispatch(getWardrobeItemsSuccess(items));
	};
}

/** Action Creator */
export function requestStart(): IWardrobeItemSearchResultsAction {
	return {
		type: REQUEST_START,
	};
}

/** Action Creator */
export function getWardrobeItemsSuccess(items: IWardrobeItemListCard[]): IWardrobeItemSearchResultsAction {
	return {
		type: GET_WARDROBEITEMS_SUCCESS,
		payload: {
			items,
		},
	};
}

/** Action Creator */
export function requestFailure(message: any): IWardrobeItemSearchResultsAction {
	return {
		type: REQUEST_FAILURE,
		payload: {
			message,
		},
	};
}

/** Action Creator */
export function setItemsPage(itemsPage: IPage): IWardrobeItemSearchResultsAction {
	return {
		type: SET_ITEMS_PAGE,
		payload: {
			itemsPage,
		},
	};
}

/** Action Creator */
export function resetData(): IWardrobeItemSearchResultsAction {
	return {
		type: RESET_DATA,
	};
}

/** Action Creator */
export function resetSearchData(): IWardrobeItemSearchResultsAction {
	return {
		type: RESET_SEARCH_DATA,
	};
}

/** Action Creator */
export function setWardrobeItemSearchKeyword(keyword: string): IWardrobeItemSearchResultsAction {
	return {
		type: SET_SEARCHED_KEYWORD,
		payload: {
			keyword,
		},
	};
}

/** Action Creator */
export function setWardrobeItemSelectedCategory(selectedCategoryId: number): IWardrobeItemSearchResultsAction {
	return {
		type: SET_SELECTED_CATEGORY,
		payload: {
			selectedCategoryId,
		},
	};
}

export function setWardrobeItemsSortOrder(sortOrder: number): IWardrobeItemSearchResultsAction {
	return {
		type: SET_SORT_ORDER,
		payload: {
			sortOrder,
		},
	};
}

/** Action Creator */
export function setRefinementSelections(refinementSelections: IRefinementGroup[]): IWardrobeItemSearchResultsAction {
	return {
		type: SET_REFINEMENT_SELECTIONS,
		payload: {
			refinementSelections,
		},
	};
}

/** Action Creator */
export function setRefinementGroups(refinementGroups: IRefinementGroup[]): IWardrobeItemSearchResultsAction {
	return {
		type: SET_REFINEMENT_GROUPS,
		payload: {
			refinementGroups,
		},
	};
}

/** Action Creator */
export function setLastRefinementItemSelection(
	lastSelectedRefinementItemId: number,
	lastSelectedRefinementGroupId: number,
): IWardrobeItemSearchResultsAction {
	return {
		type: SET_REFINEMENT_LASTSELECTION,
		payload: {
			lastSelectedRefinementItemId,
			lastSelectedRefinementGroupId,
		},
	};
}

/** Action Creator */
export function setNarrowRefinement(lastActionWasToNarrowRefinement: boolean): IWardrobeItemSearchResultsAction {
	return {
		type: SET_REFINEMENT_NARROWSELECTION,
		payload: {
			lastActionWasToNarrowRefinement,
		},
	};
}

/** Action Creator */
export function likeItemSuccess(): IWardrobeItemSearchResultsAction {
	return {
		type: LIKE_ITEM_SUCCESS,
	};
}

/** Action Creator */
export function wishlistItemSuccess(): IWardrobeItemSearchResultsAction {
	return {
		type: WISHLIST_ITEM_SUCCESS,
	};
}

/** Action Creator */
export function likeRequestStart(): IWardrobeItemSearchResultsAction {
	return {
		type: LIKE_REQUEST_START,
	};
}

/** Action Creator */
export function likeRequestFailure(message: any): IWardrobeItemSearchResultsAction {
	return {
		type: LIKE_REQUEST_FAILURE,
		payload: {
			message,
		},
	};
}
